var React = require('react');

function WarningRed (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#D0021B","d":"M12.5 22a9.5 9.5 0 1 1 0-19 9.5 9.5 0 0 1 0 19zm0-2a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15zm0-13.5a1 1 0 0 1 1 1v6a1 1 0 0 1-2 0v-6a1 1 0 0 1 1-1zm0 9.5a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"}));
}

WarningRed.defaultProps = {"width":"25","height":"25"};

module.exports = WarningRed;

WarningRed.default = WarningRed;
